import { render } from "./CliniciansIcon.vue?vue&type=template&id=72c69707"
import script from "./CliniciansIcon.vue?vue&type=script&lang=js"
export * from "./CliniciansIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__